// constants
import SliderDraggableEvent from '../../../components/slider-draggable/slider-draggable-event';

// helpers
import { clamp, classesDelayedSwap, multiClassList, querySelectorArray } from '../../../assets/js/helpers';

export default class SubmoduleSlider {

	static selector = 'submodule-slider';

	// class variables

	el = {};

	states = {
		activeDescription: null,
		total: 0
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaPrev: container.querySelector(`.${this.constructor.selector}__control-left`),
			ctaNext: container.querySelector(`.${this.constructor.selector}__control-right`),
			index: container.querySelector(`.${this.constructor.selector}__control-index`),
			descriptions: container.querySelectorAll(`.${this.constructor.selector}__image-description`),
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.states.activeDescription = querySelectorArray(this.el.descriptions, '.is-active', true);
		this.states.total = this.el.descriptions.length;
		this.#addEventListeners();
		this.setSliderDescriptionByIndex(0);
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaPrev.addEventListener('click', this.#onCtaPrevClick);
		this.el.ctaNext.addEventListener('click', this.#onCtaNextClick);

		this.el.container.addEventListener(SliderDraggableEvent.SEEKING, this.#onSliderSeeking);
	}

	#removeEventListeners = () => {
		this.el.ctaPrev.removeEventListener('click', this.#onCtaPrevClick);
		this.el.ctaNext.removeEventListener('click', this.#onCtaNextClick);

		this.el.container.removeEventListener(SliderDraggableEvent.SEEKING, this.#onSliderSeeking);
	}

	// listener methods

	#onCtaPrevClick = (e) => {
		this.el.container.dispatchEvent(new CustomEvent(SliderDraggableEvent.PREV));
	}

	#onCtaNextClick = (e) => {
		this.el.container.dispatchEvent(new CustomEvent(SliderDraggableEvent.NEXT));
	}

	#onSliderSeeking = (e) => {
		this.setSliderDescriptionByIndex(e.detail.index);
	}

	//

	setSliderDescriptionByIndex(index) {
		let loopedIndex = index;

		if (loopedIndex >= this.states.total) {
			loopedIndex = 0;
		} else if (loopedIndex < 0) {
			loopedIndex = this.states.total - 1;
		}

		const lastDescription = this.states.activeDescription;

		this.states.activeDescription = this.el.descriptions[index];
		this.el.index.innerHTML = index >= 10 ? index + 1 : `0${index + 1}`;

		classesDelayedSwap(this.states.activeDescription, lastDescription, 420);
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
